import {
    apiRequest,
    hukumanCreate,
    hukumanListPegawai,
    hukumanListHukuman
} from "../../../../../services/adapters/kepegawaian/hukumanService"

class CreateRepository {

    fetchCreate = async (query) => {
        return await apiRequest("post", hukumanCreate, {
            body: query
        }, true)
    }

    fetchPegawai = async (query) => {
        return await apiRequest("get", hukumanListPegawai, {
            body: query
        }, true)
    }

    fetchHukuman = async (query) => {
        return await apiRequest("get", hukumanListHukuman, {
            body: query
        }, true)
    }
}

export default CreateRepository